import styled from 'styled-components';
import { motion } from 'framer-motion';
import { GREEN_COLOR } from '../constants';

export const PerksTabBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 3rem;
`;

export const PerkTab = styled.button`
  background: ${({ active }) => (active ? '#000000' : '#ffffff')};
  color: ${({ active }) => (active ? '#ffffff' : '#1f2937')};
  border: 1.5px solid ${({ active }) => (active ? '#000000' : '#e5e7eb')};
  padding: 0.65rem 1.5rem;
  border-radius: 70px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    border-color: #000000;
  }
`;

export const PerksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
`;

export const PerkCard = styled(motion.div)`
  background: #ffffff;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const PerkCardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const PerkDiscountBadge = styled.span`
  background: rgba(65, 96, 54, 0.1);
  color: ${GREEN_COLOR};
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.4rem 0.9rem;
  border-radius: 50px;
  white-space: nowrap;
`;

export const PerkCategoryTag = styled.span`
  color: #9ca3af;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const PerkBusinessName = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
`;

export const PerkDescription = styled.p`
  color: #6b7280;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  flex: 1;
`;

export const PerkButton = styled.button`
  background: #000000;
  color: #ffffff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.3s;
  align-self: flex-start;

  &:hover {
    background-color: ${GREEN_COLOR};
  }
`;
